import { ProductAdd } from '#app/routes/mocra+/_form+/components/products/add.tsx'
import { ProductCard } from '#app/routes/mocra+/_form+/components/products/card.tsx'
import { type ProductDraft } from '#app/routes/mocra+/_form+/components/products/types.ts'
import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type ProductListItem = {
	readonly draft: ProductDraft
	readonly errors: readonly string[]
}

type Props = {
	readonly resources: SectionResources
	readonly products: ReadonlyArray<ProductListItem>
	readonly warnings: ReadonlyArray<string>
	readonly onAdd: (draft: ProductDraft) => void
	readonly onEdit: (index: number) => void
	readonly onRemove: (index: number) => void
}

export function ProductRosterSection({
	resources,
	products,
	warnings,
	onAdd,
	onEdit,
	onRemove,
}: Props) {
	return (
		<Section
			title="Product roster"
			description="List the SKUs or product families that require safety substantiation, listings, and recall playbooks."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
			meta={
				warnings.length > 0 ? (
					<ul className="text-destructive list-disc space-y-1 pl-5 text-xs">
						{warnings.map((warning) => (
							<li key={warning}>{warning}</li>
						))}
					</ul>
				) : null
			}
		>
			<div className="space-y-3">
				{products.length > 0 ? (
					products.map((product, index) => {
						const errors = product.errors
						return (
							<ProductCard
								key={`product-${index}`}
								index={index}
								product={product.draft}
								onEdit={() => onEdit(index)}
								onRemove={() => onRemove(index)}
								errors={errors.length > 0 ? [...errors] : undefined}
							/>
						)
					})
				) : (
					<p className="text-muted-foreground text-sm">
						Add your first product to build the roster.
					</p>
				)}
			</div>
			<ProductAdd onSubmit={onAdd} />
		</Section>
	)
}
